/* @flow */

export default class CancelInvoiceRequest {
  invoiceId: number;

  constructor(invoiceId: number) {
    this.invoiceId = invoiceId;
  }
}
